import { QUERY_KEYS } from '../../../../../consts';
import { setQuoteAudioAsListenedService } from '../../../../../services';
import { getAtomWithMutation } from '../../../../../utils';

export const setQuoteAudioAsListenedAtom = getAtomWithMutation({
  mutationKey: QUERY_KEYS.PATIENTS.SET_QUOTE_AUDIO_AS_LISTENED,
  mutationFn: () => setQuoteAudioAsListenedService,
});
